import moment from 'moment'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
import Constants from './constants'

export function humanReadableDate(timestamp) {
    if (!timestamp) return null;
    const date = new Date(timestamp);
    return moment(date, 'x').format('DD/MM/YYYY')
}

export function humanReadableDateTime(timestamp) {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  return moment(date, 'x').format('DD-MM-YYYY HH:mm[h]') 
}

export function calculateAgeFromDate (timestamp) {
  if (!timestamp || !timestamp.seconds) return null;
  const birthdate = new Date(timestamp.seconds * 1000);
  var ageDifMs = Date.now() - birthdate.getTime();
  var ageDate = new Date(ageDifMs); 
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function timeSince(timestamp) {

  if (!timestamp || !timestamp.seconds) return null;
  let date = new Date(timestamp.seconds * 1000);

  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " años";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " meses";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " días";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " horas";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutos";
  }
  return Math.floor(seconds) + " segundos";
}

export function getRiskBubbleColor(item) {
    let total = item.symptom_count;
    if (!item.last_reported_date) return '#d3d3d3'
    if (total > 3) return '#d44f55'
    if (total >= 2 && total <=3) return '#f5c163'
    return '#53b295'
}

export function getNumberOfSymptomsText(item){
    let total = item.symptom_count;
    if (!item.last_reported_date) return 'No reportado'

    if (total === 0) return '0 Síntomas'
    if (total === 1) return '1 Síntoma'
    return total + ' Síntomas'
}

export function getGenderText(item) {
  if (item.gender === 1) return 'Hombre';
  if (item.gender === 2) return 'Mujer';
  return 'Desconocido';
}

export function listContains(list, valueToCheck) {
    let isFound = false;
    list.forEach(function (value) {
        if (value==valueToCheck) {
            isFound = true;
        }
    });
    return isFound;
}

export function encrypt(rawData) {
    let encryptor = new JSEncrypt();
    encryptor.setPublicKey(Constants.rsaKeys.publicKey);
    return encryptor.encrypt(rawData);
}

export function decrypt(encryptedData) {
    let decryptor = new JSEncrypt();
    decryptor.setPrivateKey(Constants.rsaKeys.privateKey);
    return decryptor.decrypt(encryptedData);
}